import dayjs from "dayjs"
import { ApiEndpoints, reqPostNew } from "../../../config/apiClient"
import { iDadosBasicos } from "../dto/DadosBasicos.dto"

export async function retornarDatasDentroPeriodo(data_inicial: string, data_final: string):Promise<string[]> {
    let inicial = dayjs(data_inicial)
    const final = dayjs(data_final)
    const diffDias = final.diff(inicial, 'days')
    console.log(`diffDias ${diffDias}`)

    let datas:string[] = []

    if (diffDias === 0) {
        datas.push(data_inicial)
        return datas
    }

    for (let i = 0; i <= diffDias; i++) {
        datas.push(inicial.format("YYYY-MM-DD"))
        inicial = inicial.add(1, 'day')
    }
    
    return datas
}

export async function retornarLogsListaDatas(datas:string[]):Promise<any[]> {
    let logs:any[] = []

    for (let data_dia of datas) {
        const api = await reqPostNew(ApiEndpoints.metricasConsultarLogsDia, { data_dia: data_dia })
        if (api.status === 200) {
            logs = logs.concat(api.data)
        } else {
            return []
        }
    }

    return logs
}

export const COLORS_GRAPH = [
    '#008000',  // Green
    '#0000FF',  // Blue
    '#FFFF00',  // Yellow
    '#800080',  // Purple
    '#FFA500',  // Orange
    '#FFFFFF',  // White
    '#808080',  // Gray
    '#FF1493',  // Pink
    '#00CED1',  // Cyan
    '#FF4500',  // Red-Orange
    '#4682B4',  // Steel Blue
    '#98FB98',  // Pale Green
    '#DDA0DD',  // Plum
    '#F0E68C',  // Khaki
    '#87CEEB'   // Sky Blue
];

export function retornarDadosBasicos(logs:any[]):iDadosBasicos {
    let Slowest_Response = 0
    let Fastest_Response = 0

    let Response_Time_Sum = 0
    let Response_Count = 0
    let Average_Response_Time = 0

    let Payload_Size_Count = 0
    let Payload_Size_Sum = 0
    let Average_Payload_Size = 0

    let Median_Reqs_Per_Hour_Count:number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    let Median_Reqs_Per_Hour = 0

    for (let reg of logs) {
        const reg_data = dayjs(reg.timestamp)
        let hour:number = reg_data.hour()
        Median_Reqs_Per_Hour_Count[hour] = Median_Reqs_Per_Hour_Count[hour] + 1

        if (Slowest_Response <= reg.responseTime) {
            Slowest_Response = reg.responseTime
        }
        if (reg.responseTime > 0 && Fastest_Response === 0) {
            Fastest_Response = reg.responseTime
        }
        if (Fastest_Response >= reg.responseTime && reg.responseTime > 0) {
            Fastest_Response = reg.responseTime
        }
        if (typeof(reg.responseTime) === "number") {
            Response_Time_Sum = Response_Time_Sum + Number(reg.responseTime)
            Response_Count++
        }
        if (typeof(reg.reqSize) === "number") {
            Payload_Size_Sum = Payload_Size_Sum + Number(reg.reqSize)
            Payload_Size_Count++
        }
        if (typeof(reg.resSize) === "number") {
            Payload_Size_Sum = Payload_Size_Sum + Number(reg.resSize)
            Payload_Size_Count++
        }
        // if (typeof(reg.reqSize) === "number" || typeof(reg.resSize) === "number") {
        //     Payload_Size_Count++
        // }
    }

    Median_Reqs_Per_Hour_Count.sort(function(a, b){return a-b});
    console.log("CONTAGEM HORAS")
    console.log(Median_Reqs_Per_Hour_Count)
    Median_Reqs_Per_Hour = (Median_Reqs_Per_Hour_Count[12] + Median_Reqs_Per_Hour_Count[13]) / 2

    Average_Response_Time = Response_Time_Sum / Response_Count
    Average_Payload_Size = Payload_Size_Sum / Payload_Size_Count

    return {
        Slowest_Response: Slowest_Response.toFixed(2),
        Fastest_Response: Fastest_Response.toFixed(2),
        Average_Response_Time: Average_Response_Time.toFixed(2),
        Average_Payload_Size: Average_Payload_Size.toFixed(2),
        Median_Reqs_Per_Hour: Median_Reqs_Per_Hour.toFixed(2)
    }
}

